import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { useTranslate } from 'react-t7e';
import { AnimatePresence, motion } from 'framer-motion';
import Play from 'src/components/icons/Play';
import { Videos } from 'src/graphql/schema.graphql';
import { makeTransition } from 'src/utils/motion/transitions';
import { redTheme, dirRTL } from 'src/styles/theme';

export const EventCardVideosLabel = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.palette.primary};
  white-space: nowrap;
  background: transparent;
  transition: 0.25s;
  border-radius: 20px;
  padding: 4px 8px 4px 12px;
  margin-right: -6px;
  ${dirRTL} {
    padding: 4px 12px 4px 8px;
  }
`;

const PlayIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 23px;
  height: 23px;
  padding: 4px;
  border-radius: 50%;
  border: 1rpx solid currentColor;
  margin: 0 0 0 9px;
  ${dirRTL} {
    margin: 0 9px 0 0;
  }
`;

export interface EventsGridGalleryItemVideosProps {
  relatedVideos: Videos[] | undefined;
}

export const EventsGridGalleryItemVideos = ({
  relatedVideos,
}: EventsGridGalleryItemVideosProps) => {
  const { _n } = useTranslate();

  return (
    <AnimatePresence initial={false}>
      <ThemeProvider theme={redTheme}>
        {!!relatedVideos?.length && (
          <motion.div {...makeTransition({ fade: true })}>
            <EventCardVideosLabel>
              {_n(
                '{count} video',
                '{count} videos',
                relatedVideos.length,
                undefined,
                {
                  count: `${relatedVideos.length}`,
                },
              )}
              <PlayIcon>
                <Play size={9} />
              </PlayIcon>
            </EventCardVideosLabel>
          </motion.div>
        )}
      </ThemeProvider>
    </AnimatePresence>
  );
};
